import { IContentfulGateway } from '../../../interfaces/gateways/ContentfulGateway'
import { IAnimalRepository } from '../../../interfaces/gateways/animal.repository'
import { contentfulAnimalsToAnimalEntities } from '../../../entities/transformers'

export default class ViewAnimalsCase {
  constructor (
    public contentfulGateway: IContentfulGateway,
    public animalRepository: IAnimalRepository
  ) {
  }

  async execute (): Promise<void> {
    this.animalRepository.setLoading(true)
    this.animalRepository.clearResults()
    const searchTerm = this.animalRepository.getSearchTerm()
    const page = this.animalRepository.getPage()
    const params = this.animalRepository.getSearchParams()
    const animalResults = await this.contentfulGateway.searchAnimals(searchTerm, page, params)
    const animalEntities = contentfulAnimalsToAnimalEntities(animalResults.items)
    this.animalRepository.setTotal(animalResults.total)
    this.animalRepository.addAnimalsToResults(animalEntities)
    this.animalRepository.setLoading(false)
  }
}
